import React, { Component } from "react";
import { IReducerState } from "../../../states/renditionStates";
import { connect } from "react-redux";
import RenditionUrlGenerator from "../../../utils/api/renditionUrlGenerator";
import _, { isEmpty } from "lodash";
import ShowErrorPopup from "../../../mainpage/showErrorPopup";
import NormalScreenPopup from "../../../modalrelated/normalScreenPopup";
import ModalPopup from "../../../modalrelated/modalPopup";
import { enterKeyPressed } from "../../../utils/general/enterKey";
import RSCH_HTML_TRACKING_CONFIG from "../../../readership/trackingConfig";
import { getStaticEPFAccessToken } from "../../../utils/general/EpfTokensUtils";
import { addParam } from "../../../utils/general/general";

interface IStylesScoreRelativeToPeers {
  docHeaderSectionJson: any;
  multiCompanyMetaData?: { companyCode: string; ticker: string; companyNameAndTicker: string };
}

export class StylesScoreRelativeToPeers extends Component<
  IStylesScoreRelativeToPeers,
  any
> {
  public STYLES_SCORE_RELATIVE_TO_PEERS: any;
  constructor(props: IStylesScoreRelativeToPeers) {
    super(props);
    this.STYLES_SCORE_RELATIVE_TO_PEERS = React.createRef();
    this.state = {
      modalStatus: false,
    };
  }

  public openModal(e: any) {
    if (e.target.id === "modalClose") {
      this.setState({
        modalStatus: false,
      });
    } else if (this.state.modalStatus === false) {
      this.setState({
        modalStatus: true,
      });
    }
    RSCH_HTML_TRACKING_CONFIG.trackRequestStylesScorePeersClick();
  }

  public showModal() {
    // adding comapny23 styles score relative to peers popup url
    const environment = window.HTML_RENDITION.initialData.environment;
    let ticker = this.props.docHeaderSectionJson.metadata.ticker;
    const multiCompanyMetaData  = this.props.multiCompanyMetaData;
    if (window.HTML_RENDITION.isMCN) {
      if (!_.isEmpty(multiCompanyMetaData)) {
        ticker = multiCompanyMetaData.ticker;
      }
    } else {

    }
    let stylesScoreUrl =
      RenditionUrlGenerator.URL_GENERATOR.environments(environment) +
      `/directory/eppublic/company23/${ticker}/popup/ss`;

    const epfToken =  getStaticEPFAccessToken();
    if (!isEmpty(epfToken)) {
      stylesScoreUrl = addParam(stylesScoreUrl, '__epftoken', epfToken);
    }

    return (
      this.state.modalStatus && (
        <ModalPopup classList={"modal-financials"}>
          <NormalScreenPopup
            bodySource={<div></div>}
            modalBodyStyle={{ overflow: "hidden" }}
            titleSource={multiCompanyMetaData ? multiCompanyMetaData.companyNameAndTicker : this.props.docHeaderSectionJson.metadata.companyNameAndTicker}
            modalWindowStyle={{ width: "100%", height: "320px" }}
            iframeUrl={stylesScoreUrl}
            useSameHeightAsModalWindow={true}
          />
        </ModalPopup>
      )
    );
  }

  public render() {
    const stylesScoreLabel = this.props.docHeaderSectionJson.i18n.stylesScoreRelativeToPeers;
    return (
      <React.Fragment>
        <div id="requestFinancials">
          <div
            className="financials"
            onClick={(e) => this.openModal(e)}
            onKeyPress={(e) => enterKeyPressed(e, this.openModal.bind(this, e))}
          >
            {this.state.modalStatus && this.showModal()}
            <span className="icon-svg-parent">
              <span
                className="icon-svg icon-styles-score-svg"
                role="img"
                aria-label={stylesScoreLabel}
              />
            </span>
            <a
              tabIndex={0}
              role="link"
              aria-label={stylesScoreLabel}
              id="requestFinancials-financials"
              className="x-rsch-hyperlink"
              data-entitlement="STYLES_SCORE_RELATIVE_TO_PEERS"
              ref={this.STYLES_SCORE_RELATIVE_TO_PEERS}
            >
              {stylesScoreLabel}
            </a>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: IReducerState) => {
  return {
    docHeaderSectionJson: state.asyncStateReducer.docHeaderJsonData,
    multiCompanyMetaData: state.commonStateReducer.multiCompanyMetaData,
  };
};

export default connect(mapStateToProps)(StylesScoreRelativeToPeers);
